<h2 mat-dialog-title>{{ 'PHOTO.ACTIONS.UPLOAD_IMAGE' | translate }}</h2>
<mat-dialog-content>
  @if (currentFile$$ | async; as currentFile) {
    <glxy-image-editor
      [maxDimensions]="maxDimensions"
      [fileInfo]="currentFile"
      [aspectRatios]="[{ label: '1:1', value: 1 }]"
      [autoCropArea]="1"
      [maxEditorHeight]="'350px'"
      (closed)="endEdit($event)"
      maxEditorHeight="400px"
    ></glxy-image-editor>
  } @else {
    @if (files.length === 0) {
      <glxy-image-uploader
        [maxFiles]="1"
        [maxFileSize]="maxFileSize"
        [accept]="acceptedFiles"
        [hintText]="uploadPhotoHint"
        (filesChanged)="onFilesChanged($event)"
      ></glxy-image-uploader>
    }

    @if (files.length) {
      <div class="tile-container">
        <glxy-image-upload-tile
          [file]="files[0]?.data?.croppedImage || files[0].file"
          [status]="files[0].status"
          [showDeleteButton]="true"
          [showEditButton]="true"
          (delete)="deleteImage()"
          (edit)="editImage(files[0])"
        ></glxy-image-upload-tile>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" *ngIf="!!(currentFile$$ | async) === false || files.length === 0">
  <button mat-stroked-button (click)="closeUploadImageModal(false)">
    {{ 'PHOTO.ACTIONS.CANCEL' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="continue()" [disabled]="saveDisabled">
    {{ 'PHOTO.ACTIONS.UPLOAD' | translate }}
  </button>
</mat-dialog-actions>
